import { render, staticRenderFns } from "./CompaignVI.vue?vue&type=template&id=3ca346f0&scoped=true"
import script from "./CompaignVI.vue?vue&type=script&lang=js"
export * from "./CompaignVI.vue?vue&type=script&lang=js"
import style0 from "./CompaignVI.vue?vue&type=style&index=0&id=3ca346f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca346f0",
  null
  
)

export default component.exports